import React, { FC } from 'react'

import { VipCrownSwitch } from 'components/block/NewYear/VipCrownSwitch'
import { GiftItemVip } from 'components/page/ForeignProfile/Gifts/Gifts.styled'
import { PresentVipDescription } from 'components/page/ForeignProfile/Gifts/PresentVip/PresentVipDescription'
import { PresentVipDescriptionHideUser } from 'components/page/ForeignProfile/Gifts/PresentVip/PresentVipDescriptionHideUser'
import { GQLForeignRootQuery } from 'components/page/ForeignProfile/gql/__generated__/ForeignRoot'
import { VipAvatar } from 'components/page/ProfileGiftsModal/VipPresentInfo/VipAvatar'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const PresentVip: FC<{
  presenter?: NonNullable<
    NonNullable<GQLForeignRootQuery['user']>['vip']['presentVip']
  >['presenter']
  days: number
  hidden: boolean
}> = ({ presenter, days }) => {
  const { authorized } = useShallowEqualSelector(
    ({ authorizationReducer: { authorized } }) => ({
      authorized,
    })
  )

  if (presenter) {
    return (
      <GiftItemVip>
        <VipAvatar
          photo={presenter.photos.default?.urls.square}
          size="100%"
          type={`present-vip-${presenter.id}`}
        />
        {authorized && (
          <PresentVipDescription presenter={presenter} days={days} />
        )}
      </GiftItemVip>
    )
  }

  return (
    <GiftItemVip>
      <VipCrownSwitch width="100%" height="100%" />
      {authorized && <PresentVipDescriptionHideUser days={days} />}
    </GiftItemVip>
  )
}
